/* bba-page.js: delivery dates, offer tier picker, mobile sticky bar */
(function () {
  var root = document.querySelector('[data-bba]');
  if (!root) return;
  var days = +root.getAttribute('data-bba-days') || 3;
  var d = new Date(); d.setDate(d.getDate() + days);
  var D = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var FM = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  [].forEach.call(root.querySelectorAll('[data-bba-date]'), function (e) { e.textContent = D[d.getDay()] + ', ' + M[d.getMonth()] + ' ' + d.getDate(); });
  var t = new Date();
  [].forEach.call(root.querySelectorAll('[data-bba-today]'), function (e) { e.textContent = FM[t.getMonth()] + ' ' + t.getDate() + ', ' + t.getFullYear(); });

  [].forEach.call(root.querySelectorAll('[data-bba-offer]'), function (box) {
    var tiers = [].slice.call(box.querySelectorAll('[data-bba-tier]'));
    var btn = box.querySelector('[data-bba-buy]');
    function pick(x) {
      tiers.forEach(function (y) { var on = y === x; y.classList.toggle('is-on', on); var i = y.querySelector('input'); if (i) i.checked = on; });
      var l = x.getAttribute('data-link'); if (btn && l) btn.setAttribute('href', l);
    }
    tiers.forEach(function (x) { x.addEventListener('click', function () { pick(x); }); });
    var first = box.querySelector('[data-bba-tier].is-on') || tiers[0];
    if (first) pick(first);
  });

  [].forEach.call(root.querySelectorAll('[data-bba-ends]'), function (tm) {
    var end = Date.parse(tm.getAttribute('data-bba-ends'));
    if (isNaN(end)) return;
    var dd = tm.querySelector('[data-d]'), db = tm.querySelector('[data-dbox]'), h = tm.querySelector('[data-h]'), m = tm.querySelector('[data-m]'), s = tm.querySelector('[data-s]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { tm.hidden = true; clearInterval(iv); return; }
      tm.hidden = false;
      var days = Math.floor(left / 86400); if (db) db.hidden = days < 1; if (dd) dd.textContent = days;
      h.textContent = pad(Math.floor(left % 86400 / 3600)); m.textContent = pad(Math.floor(left % 3600 / 60)); s.textContent = pad(left % 60);
    }
    var iv = setInterval(tick, 1000); tick();
  });

  var bar = root.querySelector('[data-bba-bar]'), cta = root.querySelector('[data-bba-first]');
  if (bar && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      bar.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }).observe(cta);
  }
})();
